import { moneyFormatter, numberFormatter } from "../../gridFormatters"

export const typeLines = {
    'capacity': [
        {
            name: 'Allocated',
            field: 'capacity',
            dataLabels: {format: '{point.y:,.0f}'},
            tooltip: {pointFormat: '{series.name}: <b>{point.y:,.0f}</b>'},
        }
    ],
    'used': [
        {
            name: 'Used',
            field: 'used',
            dataLabels: {format: '{point.y:,.0f}'},
            tooltip: {pointFormat: '{series.name}: <b>{point.y:,.0f}</b>'},
        }
    ],
    'cpu': [
        {
            name: 'CPU',
            field: 'cpu',
            dataLabels: {format: '{point.y:,.0f}'},
            tooltip: {pointFormat: '{series.name}: <b>{point.y:,.0f}</b>'},
        }
    ],
    'memory': [
        {
            name: 'Memory',
            field: 'memory',
            dataLabels: {format: '{point.y:,.0f}'},
            tooltip: {pointFormat: '{series.name}: <b>{point.y:,.0f}</b>'},
        }
    ],
    'capacity_cost': [
        {
            name: 'Cost',
            field: 'capacity_cost',
            dataLabels: {format: '${point.y:,.0f}'},
            tooltip: {pointFormat: '${series.name}: <b>${point.y:,.0f}</b>'},
        }
    ],
    'cost_per_memory': [
        {
            name: 'Cost',
            field: 'cost_per_memory',
            dataLabels: {format: '${point.y:,.0f}'},
            tooltip: {pointFormat: '${series.name}: <b>${point.y:,.0f}</b>'},
        }
    ],
    'cost_per_cpu': [
        {
            name: 'Cost',
            field: 'cost_per_cpu',
            dataLabels: {format: '${point.y:,.0f}'},
            tooltip: {pointFormat: '${series.name}: <b>${point.y:,.0f}</b>'},
        }
    ],
    'total_cost': [
        {
            name: 'Total Cost',
            field: 'total_cost',
            dataLabels: {format: '${point.y:,.0f}'},
            tooltip: {pointFormat: '${series.name}: <b>${point.y:,.0f}</b>'},
        }
    ]
}

export const typeDefs = {
    'capacity': [
        {
            "field": "capacity",
            "headerName": "Capacity Allocated",
            "cellRenderer": numberFormatter
        },
        {
            "field": "capacity_cost",
            "headerName": "Cost Per GiB",
            "cellRenderer": moneyFormatter
        }
    ],
    'used': [
        {
            "field": "used",
            "headerName": "Capacity Used",
            "cellRenderer": numberFormatter
        },
        {
            "field": "capacity_cost",
            "headerName": "Cost Per GiB",
            "cellRenderer": moneyFormatter
        }
    ],
    'cpu': [
        {
            "headerName": 'CPU',
            "field": 'cpu',
            "cellRenderer": numberFormatter
        },
        {
            "headerName": 'Cost Per CPU',
            "field": 'cost_per_cpu',
            "cellRenderer": moneyFormatter
        }
    ],
    'memory': [
        {
            "headerName": 'Memory',
            "field": 'memory',
            "cellRenderer": numberFormatter
        },
        {
            "headerName": 'Cost Per Memory',
            "field": 'cost_per_memory',
            "cellRenderer": moneyFormatter
        }
    ],
    'capacity_cost': [
        {
            "headerName": 'Cost Per GiB',
            "field": 'capacity_cost',
            "cellRenderer": moneyFormatter
        }
    ],
    'cost_per_memory': [
        {
            "headerName": 'Cost Per Memory',
            "field": 'cost_per_memory',
            "cellRenderer": moneyFormatter
        }
    ],
    'cost_per_cpu': [
        {
            "headerName": 'Cost Per CPU',
            "field": 'cost_per_cpu',
            "cellRenderer": moneyFormatter
        }
    ],
    'total_cost': [
        {
            "headerName": 'Total Cost',
            "field": 'total_cost',
            "cellRenderer": moneyFormatter
        }
    ]
}